module.exports = __webpack_public_path__ + "img/24.111925bb.png";